/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"
import {excludeBrand} from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

const _brand = process.env.VUE_APP_BRAND
const brand = excludeBrand.includes(_brand) ? null : process.env.VUE_APP_BRAND

// *From Auth - Data will be received from auth provider
const userDefaults = {
    color_scheme: null,
    created_at: null,
    dashboard: null,
    email: null,
    email_verified_at: null,
    hash: null,
    id: null,
    is_active: null,
    locale: null,
    menu_state: null,
    name: null,
    permissions: null,
    system_settings: null,
    role_id: null,
    team: {
        is_internal: null,
        is_active: null
    },
    roles: {
      name: null
    },
    team_id: null,
    updated_at: null,
    photoURL: brand ? require(`@assets/images/portrait/${brand}.png`) : require("@assets/images/portrait/small/avatar-s-13.jpg"),
}

const userDefaultsAutologin = {
    color_scheme: null,
    created_at: null,
    dashboard: null,
    email: null,
    email_verified_at: null,
    hash: null,
    id: null,
    is_active: null,
    locale: null,
    menu_state: null,
    name: null,
    permissions: null,
    system_settings: null,
    role_id: null,
    team: {
        is_internal: null,
        is_active: null
    },
    roles: {
      name: null
    },
    team_id: null,
    updated_at: null,
    photoURL: brand ? require(`@assets/images/portrait/${brand}.png`) : require("@assets/images/portrait/small/avatar-s-13.jpg"),
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
      return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
      return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser           : userDefaults,
    UsersTable              : [],
    EditUser                : [],
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    is_touch_device         : is_touch_device(),
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,
    userPermissions: [],
    systemSettings: {},
    aUser: userDefaultsAutologin,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    process: process.env.NODE_ENV !== 'production' ? process.env : null,
    ajaxRequest: null,
    wrapperWidth: 0,
    isTeamAutologin: null
}

export default state
